import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HistoryIcon from "@mui/icons-material/History";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import CheckPermissions from "../../../authorization/authorization";
import BasicTable from "../../../components/basicTable/basicTable";
import DynamicTable from "../../../components/dynamicTable/DynamicTable";
import { AllPermissions, AllRoles } from "../../../network/APIs/APIs";
import { cfpBaseUrl } from "../../../network/urls";
import { tableStyle } from "../../../style/common";
import "./RoleManagementTable.scss";
import SearchIcon from "@mui/icons-material/Search";

export default function RoleManagementTable() {
  //#region
  const [newusersToDataGrid, setNewUsersToDataGrid] = useState([]);
  const [open, setOpen] = useState(false);
  const [open2, setopen2] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [openHistory, setOpenHistory] = useState(false);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [dltuser, setdltuser] = useState();
  const [tableRoles, setTableRoles] = useState([]);
  const [tableRolesToDataGrid, setTableRolesToDataGrid] = useState([]);
  const [sortedPermissions, setSortedPermissions] = useState([]);
  const [viewBackdrop, setViewBackdrop] = React.useState(false);
  const [viewBackdropOfMainTable, setViewBackdropOfMainTable] =
    React.useState(false);
  const [historyDetails, setHistoryDetails] = useState([
    {
      premAsigningOrderAuthority: "",
      premAsigningOrderDate: "",
      premAsigningOrderImplimentationDate: "",
      premAsigningOrderImplimentedBy: "",
      premAsigningOrderNo: "",
    },
  ]);

  const Navigate = useNavigate();

  const { token, permissions } = useSelector((state) => state.auth);
  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    const getAllRoles = async () => {
      setViewBackdropOfMainTable(true);
      let allroles = await AllRoles(token, permissions);
      setTableRoles(allroles);
      setViewBackdropOfMainTable(false);
    };
    getAllRoles();
  }, []);

  useEffect(() => {
    const getAllPermissions = async () => {
      setViewBackdrop(true);
      let { sortedAllPermissions } = await AllPermissions(token, permissions);
      setSortedPermissions(sortedAllPermissions);
      setViewBackdrop(false);
    };
    getAllPermissions();
  }, []);

  const getLevel = (x) => {
    switch (x) {
      case 1:
        return "PITC";
      case 2:
        return "DISCO";
      case 3:
        return "Circle";
      case 4:
        return "Division";
      case 51:
        return "Customer Support Center";
      case 52:
        return "Sub division";
    }
  };
  useEffect(() => {
    const myArray = tableRoles;
    const tempArray = [];
    if (myArray) {
      //for(let i = 0; i <= myArray.length; i++){
      myArray.forEach((item) => {
        const dataGridObject = {
          id: item.id,
          name: item.name,
          level: getLevel(item.level),
          createdBy: item.created_by,
          createdAt: convertDate(item.created_at),
          roleType:item.roleTypeName
        };
        tempArray.push(dataGridObject);
      });
    } else {
      const dataGridObject = {
        id: " ",
        name: "",
        level: " ",
        createdBy: " ",
        createdAt: statusFunc(" "),
      };
      tempArray.push(dataGridObject);
    }
    setTableRolesToDataGrid(tempArray);
    setFilteredData(tempArray);
  }, [tableRoles]);

  const filterRole = (roleId) => {
    let roleData = tableRoles.find((item) => item.id === roleId);
    return roleData;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setopen2(false);
  };

  const handleCloseHistory = () => {
    setOpenHistory(false);
  };

  const onDelete = async () => {
    var formdata = new FormData();
    formdata.append("roleId", dltuser);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "role/deleteRole", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          window.location.reload();
        } else {
          console.log(
            "Unable to delete role! Delete Users with this role before trying again. ",
          );
        }
      })
      .catch((error) => console.log("error", error));
    handleClose2();
  };

  const convertDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const convertdatetime = (datetimestring) => {
    if (datetimestring) {
      const converted = moment(datetimestring).format("llll");
      return converted;
    }
  };

  const tblColumns = [
    {
      field: "id",
      headerName: "Role ID",
      align: "left",
      headerAlign: "center",
           sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "name",
      headerName: "Role Name",
      align: "left",
      headerAlign: "center",
           sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "level",
      headerName: "Level",
      align: "left",
      headerAlign: "center",
           sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "roleType",
      headerName: "Role Type",
      align: "left",
      headerAlign: "center",
           sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "createdBy",
      headerName: "Created By",
      align: "left",
      headerAlign: "center",
           sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      align: "left",
      headerAlign: "center",
           sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "buttons",
      headerName: "Action",
      align: "center",
      headerAlign: "center",
           sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      renderCell: (params) => {
        const onViewRole = async (e) => {
          e.stopPropagation(); // don't select this row after clicking
          let roleData = tableRoles.find((item) => item.id === params.id);

          var formdata = new FormData();
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          formdata.append("roleId", roleData.id);

          var requestOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
            redirect: "follow",
          };

          await fetch(cfpBaseUrl + "role/getPremRole", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
                let permissions = result.data;
                let permIntArray = [];
                permissions.forEach((item) => {
                  permIntArray.push(item.perm_id);
                });
                roleData.permissions = permIntArray;
              } else {
                roleData.permissions = [];
              }
            })
            .catch((error) => console.log("error", error));
          setDialogRowData(roleData);
          setOpen(true);
        };

        const onEditRole = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          let roleDetails = filterRole(params.id);
          Navigate("/role-management/update-role", { state: { roleDetails } });
        };

        const onDeleteRole = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          setdltuser(params.id);
          setopen2(true);
        };

        const onViewRoleHistory = async (e) => {
          e.stopPropagation(); // don't select this row after clicking
          let roleData = tableRoles.find((item) => item.id === params.id);

          var formdata = new FormData();
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          formdata.append("roleId", roleData.id);

          var requestOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
            redirect: "follow",
          };

          await fetch(
            cfpBaseUrl + "role/getLatestPremAsigningOrderHist",
            requestOptions,
          )
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
                let history = result.data;
                setHistoryDetails(result.data);
                setOpenHistory(true);
              }
            })
            .catch((error) => console.log("error", error));
        };

        return (
          <>
            <Box>
              <IconButton
                onClick={onViewRoleHistory}
                aria-label="kill"
                size="small"
                sx={{ margin: 0, padding: 0 }}
              >
                <HistoryIcon fontSize="inherit" sx={{ color: "orange" }} />
              </IconButton>
              {CheckPermissions(
                permissions,
                "Access Management",
                "Role Management",
                "Read",
              ) && (
                <IconButton
                  onClick={onViewRole}
                  aria-label="view"
                  size="small"
                  sx={{ margin: 0.4, padding: 0 }}
                >
                  <VisibilityIcon
                    sx={{ color: "skyblue" }}
                    fontSize="inherit"
                  />
                </IconButton>
              )}
              {CheckPermissions(
                permissions,
                "Access Management",
                "Role Management",
                "Update",
              ) && (
                <IconButton
                  onClick={onEditRole}
                  aria-label="edit"
                  size="small"
                  sx={{ margin: 0.4, padding: 0 }}
                >
                  <EditIcon fontSize="inherit" sx={{ color: "blue" }} />
                </IconButton>
              )}
              {CheckPermissions(
                permissions,
                "Access Management",
                "Role Management",
                "Delete",
              ) && (
                <IconButton
                  onClick={onDeleteRole}
                  aria-label="delete"
                  size="small"
                  sx={{ margin: 0, padding: 0 }}
                >
                  <DeleteIcon fontSize="inherit" sx={{ color: "red" }} />
                </IconButton>
              )}
            </Box>
          </>
        );
      },
    },
  ];

  const statusFunc = (x) => {
    return x === 1 ? "Active" : "InActive";
  };

  function RoleDetailsPermissionItem({ item, checkedItems, isRoot }) {
    const { idt, name, children } = item;
    const isChecked = (checkedItems || []).includes(idt);

    const checkboxRow = (
      <div className={`perm-row perm-row--readonly${isRoot ? " perm-row-root" : ""}`}>
        <input type="checkbox" id={`role-detail-perm-${idt}`} checked={isChecked} disabled readOnly />
        <label htmlFor={`role-detail-perm-${idt}`}>{name}</label>
      </div>
    );

    if (isRoot) {
      if (children && children.length > 0) {
        return (
          <Accordion
            className="perm-accordion"
            defaultExpanded
            disableGutters
            elevation={0}
            square
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="perm-expand-icon" />}
              className="perm-accordion-summary"
            >
              <span className="perm-summary-stop">{checkboxRow}</span>
            </AccordionSummary>
            <AccordionDetails className="perm-accordion-details">
              <div className="perm-children perm-children-under-accordion">
                {children.map((child) => (
                  <RoleDetailsPermissionItem
                    key={child.idt}
                    item={child}
                    checkedItems={checkedItems}
                  />
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        );
      }
      return <div className="perm-root perm-root-simple">{checkboxRow}</div>;
    }

    return (
      <>
        {checkboxRow}
        {children && children.length > 0 && (
          <div className="perm-children">
            {children.map((child) => (
              <RoleDetailsPermissionItem
                key={child.idt}
                item={child}
                checkedItems={checkedItems}
              />
            ))}
          </div>
        )}
      </>
    );
  }

  function RoleDetailsPermissionTree({ data, userPermissions }) {
    return (
      <div className="permissions-grid">
        {data.map((rootItem) => (
          <RoleDetailsPermissionItem
            key={rootItem.idt}
            item={rootItem}
            checkedItems={userPermissions}
            isRoot
          />
        ))}
      </div>
    );
  }

  function getName(id) {
    return tableRoles.find((item) => item.id === id).name;
  }

  const HistoryColumns = [
    {
      header: "Order No.",
      accessorKey: "premAsigningOrderNo",
    },
    {
      header: "Authority",
      accessorKey: "premAsigningOrderAuthority",
    },
    {
      header: "Order Date",
      accessorKey: "premAsigningOrderDate",
    },
    {
      header: "Implementation Date",
      accessorKey: "premAsigningOrderImplimentationDate",
    },
    {
      header: "Implemented By",
      accessorKey: "premAsigningOrderImplimentedBy",
    },
  ];
  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    const queryForSearch = query.trim().toLowerCase();

    if (!queryForSearch) {
      setFilteredData(tableRolesToDataGrid);
      return;
    }

    const filtered = tableRolesToDataGrid.filter((row) => {
      return (
        String(row.id ?? "")
          .toLowerCase()
          .includes(queryForSearch) ||
        String(row.name ?? "")
          .toLowerCase()
          .includes(queryForSearch) ||
        String(row.level ?? "")
          .toLowerCase()
          .includes(queryForSearch) ||
        String(row.createdBy ?? "")
          .toLowerCase()
          .includes(queryForSearch) ||
        String(row.createdAt ?? "")
          .toLowerCase()
          .includes(queryForSearch)
      );
    });

    setFilteredData(filtered);
  };
  return (
    <>
      <Box className="form-box">
        {/* <Box className='main-heading'>
          <h2>
            Role Management
          </h2>
          <div className='btn2'>
            {
              CheckPermissions(permissions, 'Access Management', 'Role Management', 'Create') &&
              <Link to="/role-management/new-role">
                <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} >
                  Create New Role
                </Button>
              </Link>
            }
          </div>
        </Box> */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <h3 className="page-title">Role Management</h3>

          <div
            style={{
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
              padding: "5px 10px",
              border: "1px solid grey",
              margin: "0px",
            }}
          >
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearch}
              placeholder="Search by ID, Role Name or Level Or Created By/At"
              maxLength={20}
              style={{
                flex: 1,
                padding: "8px",
                border: "none",
                backgroundColor: "transparent",
                outline: "none",
                fontSize: "13px",
                minWidth: "300px",
              }}
            />
            <SearchIcon
              sx={{
                color: "#09669d",
                width: 30,
                height: 30,
                borderRadius: "8px",
                padding: "6px",
                cursor: "pointer",
                transition: "background-color 0.3s",
                "&:hover": {
                  color: "#074f7d",
                },
              }}
            />
          </div>
        </Box>
        <Box className="application-table">
          <BasicTable
            data={filteredData}
            columns={tblColumns}
            sx={tableStyle}
            handleRowClick={() => {}}
            rowHeight={37.5}
            pageSize={18}
            rowsPerPageOptions={[18, 30, 60]}
            rowsPageOption={false}
            isLoading={viewBackdropOfMainTable}
            getRowStyle={(params) => {
              return params.indexRelativeToCurrentPage % 2 === 0
                ? tableStyle.evenRow
                : tableStyle.oddRow;
            }}
          />
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="role-details-title"
        maxWidth="lg"
        fullWidth
        className="role-details-dialog"
        PaperProps={{ className: "role-details-dialog__paper" }}
      >
        <DialogTitle id="role-details-title" className="role-details-dialog__title">
          <Typography component="span" className="role-details-dialog__heading">
            Role Details
          </Typography>
          <IconButton
            onClick={handleClose}
            aria-label="Close role details"
            className="role-details-dialog__close"
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="role-details-dialog__content">
          <div className="section-card section-card--accent">
            <div className="section-title">Basic Information</div>
            <div className="role-meta-grid">
              <div className="role-meta-item">
                <span className="role-meta-label">ID</span>
                <span className="role-meta-value">{dialogRowData.id ?? "-"}</span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Name</span>
                <span className="role-meta-value">{dialogRowData.name ?? "-"}</span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Role Type</span>
                <span className="role-meta-value">
                  {dialogRowData.roleTypeName ?? "-"}
                </span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Level</span>
                <span className="role-meta-value">
                  {dialogRowData.level != null ? getLevel(dialogRowData.level) : "-"}
                </span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Status</span>
                <span
                  className={`role-meta-value role-meta-value--status ${
                    dialogRowData.status === 1 ? "is-active" : "is-inactive"
                  }`}
                >
                  {statusFunc(dialogRowData.status)}
                </span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Show All Applications</span>
                <span className="role-meta-value">
                  {dialogRowData.showAllApplicationsFlag === 1
                    ? "Yes"
                    : dialogRowData.showAllApplicationsFlag === 0
                      ? "No"
                      : "-"}
                </span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Created By</span>
                <span className="role-meta-value">{dialogRowData.created_by ?? "-"}</span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Created At</span>
                <span className="role-meta-value">
                  {dialogRowData.created_at
                    ? convertdatetime(dialogRowData.created_at)
                    : "-"}
                </span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Last Updated By</span>
                <span className="role-meta-value">
                  {dialogRowData.updated_by ? dialogRowData.updated_by : "-"}
                </span>
              </div>
              <div className="role-meta-item">
                <span className="role-meta-label">Last Updated At</span>
                <span className="role-meta-value">
                  {dialogRowData.updated_at
                    ? convertdatetime(dialogRowData.updated_at)
                    : "-"}
                </span>
              </div>
            </div>
          </div>

          <div className="section-card permissions-wrap">
            <div className="section-title-row">
              <div>
                <div className="section-title">Permissions</div>
                <p className="section-subtitle">
                  Read-only view of permissions assigned to this role. Expand each module to review nested access.
                </p>
              </div>
              <span className="perm-selected-pill" aria-live="polite">
                {(dialogRowData.permissions || []).length} assigned
              </span>
            </div>
            <RoleDetailsPermissionTree
              data={sortedPermissions}
              userPermissions={dialogRowData.permissions}
            />
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {" Are you sure to delete this record"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose2}>Cancel</Button>
          <Button onClick={onDelete} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openHistory} onClose={handleCloseHistory}>
        <DialogTitle>History of Role</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container spacing={2} sx={{ display: "flex" }}>
              <Grid item sx={{ display: "flex" }}>
                <Typography>Role ID:</Typography>
                <Typography>
                  {historyDetails
                    ? historyDetails[0].effectedRoleIdByAsigningOrder
                      ? historyDetails[0].effectedRoleIdByAsigningOrder
                      : "-"
                    : "-"}
                </Typography>
              </Grid>
              <Grid item sx={{ display: "flex" }}>
                <Typography>Role Name:</Typography>
                <Typography>
                  {historyDetails
                    ? historyDetails[0].effectedRoleIdByAsigningOrder
                      ? getName(historyDetails[0].effectedRoleIdByAsigningOrder)
                      : "-"
                    : "-"}
                </Typography>
              </Grid>
              <Grid item lg={12}>
                <DynamicTable data={historyDetails} columns={HistoryColumns} />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHistory}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
